<template>
  <div class="home mt-2">
    <div>
      <bread-crumbs
        :from="{name: 'Roles', type: 'share-alt',link:'roles'}"
        :to="{name: 'All Roles'}"
      ></bread-crumbs>
    </div>

    <router-view></router-view>
    <page-title
      :title="'Roles'"
      description="Create new user roles to define access hierachy."
      :route="{name: 'roles-create'}"
    />
    <a-row>
      <a-col :span="24" style="margin-left:20px; margin-right:20px">
        <filter-card @filter="filterSearch" :name="'Roles'">
          <div slot="inputFields">
            <a-col :span="5" class="mobile-full-width mr-1">
              <small class="text-opacity">By Name</small>
              <div>
                <a-input
                  v-model="moreParams.search"
                  class="filter-input"
                  placeholder="Name of Role"
                />
              </div>
            </a-col>
            <a-col :span="5" class="mobile-full-width mr-1">
              <small class="text-opacity">Status</small>
              <div>
                <a-select v-model="moreParams.active" style="width: 90%" placeholder="Role Status">
                  <a-select-option value="true">Active</a-select-option>
                  <a-select-option value="false">Deactivated</a-select-option>
                </a-select>
              </div>
            </a-col>
            <a-col :span="4" class="mobile-full-width">
              <small class="text-opacity">Per Page</small>
              <div>
                <a-select
                  v-model="moreParams.per_page"
                  style="width: 90%"
                  placeholder="Employee's Creation Date"
                >
                  <a-select-option value="10">10</a-select-option>
                  <a-select-option value="20">20</a-select-option>
                  <a-select-option value="30">30</a-select-option>
                  <a-select-option value="40">40</a-select-option>
                  <a-select-option value="50">50</a-select-option>
                </a-select>
              </div>
            </a-col>
          </div>
        </filter-card>
      </a-col>
      <a-col :span="24" class="mt-4" style="margin-left:20px">
        <vuetable
          ref="vuetable"
          :api-url="api"
          :fields="columns"
          @vuetable:pagination-data="onPaginationData"
          :append-params="moreParams"
          data-path="data"
          pagination-path
        >
          <template slot="status" slot-scope="props">
            <span v-if="props.rowData.active === 1">
              <a-badge status="success"/>Active
            </span>
            <span v-else>
              <a-badge status="error"/>Deactivated
            </span>
          </template>
          <template slot="actions" slot-scope="props">
            <div v-if="$route && $route.query && $route.query.mode">
              <router-link
                style="color:black"
                :to="{name: 'assign-roles-permission', params: {id: props.rowData.id}}"
              >
                <button class="btn btn-lightgray-round">
                  <a-icon type="plus" style="padding-right:7px"/>Assign Permission
                </button>
              </router-link>
            </div>
            <div v-else>
              <router-link
                style="color:black"
                :to="{name: 'roles-show', params: {id: props.rowData.id}}"
              >
                <button class="btn btn-lightgray-round">
                  <a-icon type="plus" style="padding-right:7px"/>View More
                </button>
              </router-link>
            </div>
          </template>
          <template slot="roles" slot-scope="props">
            <div v-if="props.rowData.permissions && props.rowData.permissions.length >= 1">
              <a-tag>
                <router-link
                  :to="{name: 'permissions-show', params: {id: props.rowData.permissions[0].id}}"
                >{{props.rowData.permissions[0].name}}</router-link>
              </a-tag>

              <a-dropdown v-if="props.rowData.permissions.length > 1">
                <a class="ant-dropdown-link" href="#">
                  <small>+ {{props.rowData.permissions.length - 1}} more.</small>
                  <a-icon type="down"/>
                </a>
                <a-menu slot="overlay">
                  <a-menu-item
                    :key="index"
                    v-for="(perm,index) in props.rowData.permissions.slice(1)"
                  >
                    <router-link
                      :to="{name: 'permissions-show', params: {id: perm.id}}"
                    >{{perm.name}}</router-link>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </div>
            <div v-else>
              <small>No assigned Permission</small>
            </div>
          </template>
          <template slot="more" slot-scope="props">
            <a-dropdown>
              <a class="ant-dropdown-link" href="#">
                <div class="btn-hover">
                  <a-icon type="ellipsis"/>
                </div>
              </a>
              <a-menu slot="overlay">
                <a-menu-item v-if="$route && $route.query && $route.query.mode">
                  <router-link :to="{name: 'roles-show', params: {id: props.rowData.id}}">View Role</router-link>
                </a-menu-item>
                <a-menu-item v-else>
                  <router-link
                    :to="{name: 'assign-roles-permission', params: {id: props.rowData.id}}"
                  >Assign Permission</router-link>
                </a-menu-item>
                <a-menu-item>
                  <router-link :to="{name: 'roles-edit', params: {id: props.rowData.id}}">Edit Role</router-link>
                </a-menu-item>
                <a-menu-item>
                  <a href="javascript:;" style="color:red; opacityL:.7">Delete Role</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </template>
        </vuetable>
        <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"/>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import "@/assets/css/table.scss";
import PageTitle from "@/components/Headers/PageTitle";
import Vuetable from "vuetable-2";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import FilterCard from "@/components/Cards/Filters/Index";
import BreadCrumbs from "@/components/Headers/BreadCrumbs.vue";
import moment from "moment";
export default {
  components: {
    PageTitle,
    Vuetable,
    VuetablePagination,
    FilterCard,
    BreadCrumbs
  },
  data() {
    return {
      api: this.$baseApi + "/role",
      moreParams: {
        token: this.$auth.token(),
        search: "",
        active: "",
        start_date: "",
        per_page: ""
      },
      columns: [
        {
          name: "__sequence", // <----
          title: "S/N"
        },
        {
          name: "name",
          title: "Name",
          sortField: "name"
        },
        {
          name: "description",
          title: "Description",
          callback: d => {
            if (d.length > 30) {
              return d.substring(0, 5) + "...";
            }
            return d;
          }
        },
        {
          name: "__slot:roles",
          title: "Permissions"
        },
        {
          name: "__slot:status",
          title: "Status"
        },
        {
          name: "created_at",
          title: "Created Date",
          callback: s => {
            return moment(s).format("Do MMMM, YYYY");
          }
        },
        {
          name: "__slot:actions",
          title: "Actions"
        },
        {
          name: "__slot:more",
          title: "More"
        }
      ]
    };
  },
  computed: {},
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    filterSearch() {
      // this.$events.fire("filter-set", this.searchParams.search);
      const hide = this.$message.loading(
        "Filtering Users, Hold on a Minute",
        20
      );
      this.$nextTick(() => {
        this.$refs.vuetable.refresh();
        setTimeout(hide, 100);
      });
    }
  },
  mounted() {
    var emptyTable = document.createElement("td");
    emptyTable.innerHTML = `<center><div class="ant-empty"> <div class="ant-empty-image"><img alt="No Data" src="data:image/svg+xml;base64,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"></div><p class="ant-empty-description" style="text-align:center">No Data available yet.</p></div></center>`;
    var oldEmptyTable = document.getElementsByClassName(
      "vuetable-empty-result"
    )[0];
    oldEmptyTable.parentNode.replaceChild(emptyTable, oldEmptyTable);

    this.$events.$on("filter-set", eventData => this.onFilterSet(eventData));
  },
  watch: {
    $route() {
      this.$refs.vuetable.refresh();
    }
  }
};
</script>
